import InsurancePayBlock from './InsurancePayBlock'
import PatientPaymentBlock from './PatientPaymentBlock'
import LoadingSpinner from '../../../components/LoadingSpinner'
import React from 'react'
import { useSnlInvoiceStore } from '../../../stores/SNLInvoiceStore'

export default function UnderstandingYourCosts() {
  const { snlInvoice, error, editedInvoice } = useSnlInvoiceStore()

  const invoice = editedInvoice ?? snlInvoice

  if ( !invoice && !error ) return <LoadingSpinner />

  return (
    <div className="flex flex-col gap-4 w-full max-w-2xl mb-12">
      <InsurancePayBlock
        totalInsPayment={invoice?.total_ins_payment || 0}
        payer1Name={invoice?.payer1_name || ``}
        payer2Name={invoice?.payer2_name || ``}
        payer3Name={invoice?.payer3_name || ``}
        deductible={invoice?.deductible || 0}
        deductibleRemaining={invoice?.deductible_remaining || 0}
        coinsurancePercentage={invoice?.coinsurance_percentage || 0}
      />
      <PatientPaymentBlock
        totalPatientOwes={invoice?.total_patient_owes || 0}
        invoice={invoice || undefined}
      />
    </div>
  )
}
